export const VARIATION = [
  'low',
  'medium',
  'high'
]
